import { createStyles, makeStyles } from '@material-ui/core';
import { ChatSharp } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useDocumentPermissions, useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});

/**
 * Document widget component to draw Annotation
 */
export const AddAnnotationWidget = props => {
  var _viewerState$rotation, _viewerState$rotation2;

  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  const permissions = useDocumentPermissions();
  const pageRotation = ((_viewerState$rotation = viewerState.rotation) === null || _viewerState$rotation === void 0 ? void 0 : (_viewerState$rotation2 = _viewerState$rotation.find(rotation => rotation.pageNum === viewerState.activePage)) === null || _viewerState$rotation2 === void 0 ? void 0 : _viewerState$rotation2.degree) || 0;
  return /*#__PURE__*/React.createElement(ToggleBase, {
    disabled: !permissions.canEdit || pageRotation !== 0,
    classes: classes,
    active: viewerState.activeShapePlacing === 'annotation',
    title: localization.addAnnotation,
    setValue: value => viewerState.updateState({
      activeShapePlacing: value ? 'annotation' : 'none',
      isPlacingCommentMarker: false
    })
  }, /*#__PURE__*/React.createElement(ChatSharp, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.activeShapePlacing === 'annotation'
    })
  }));
};
//# sourceMappingURL=add-annotation.js.map